<div [class.loader-hidden]="!show">
    <div class="loader-overlay">
        <div>
            <div class="progress" *ngIf="show">
                <div class="spinner me-3"></div>
                <div class="text">{{'Loading...'|translate}}</div>
            </div>
        </div>
    </div>
</div>
